import React, {Component} from 'react';
import axios from 'axios';
import './Myprofileaddress.css';
import './Complaintitem.css';
class Myprofileaddress extends React.Component {

  constructor(props){
    super(props);
    
}
  render() {
   

    return <div>

<div className="row  ">


  <div className="    center-space">
  <div className="text-center">
          <a className="" href=""> <img src="/assets/images/logo.svg" alt="" title="" className="img-fluid" /> </a>
      </div>
  <form>
      <div className="ml-3">
        
      <a className="" href=""> <img src="/assets/images/img_avatar.png" alt="" title="" className="avatar-img mt-4 ml-4" /> </a>

                    <div class="row-form  mt-3 center-space ml-3 ">
                        <h6  class="green-label "> Full Name</h6>
                        <input class="form-controls " type="text"    />
                    </div> 
                        
                    <div class="row-form   center-space  mb-2 ml-3 ">
                        <h6  class="green-label ">E-mail Address</h6>
                        <input class="form-controls " type="text" placeholder="" id="email" />
                    </div>
               </div>     
                    <div className=" mb-2 mt-4  ">  
                      <button type="button" class="  btnn btn-hover btn-outline-success tag-btn mob-btn-mb-15  ">Back</button>
                      <button type="button" type="submit" class=" add-to-cart2 btnn tag-btn  mt-0 mb-2 "  >Submit</button>
                    </div>

                    </form>
      </div>
      


   




</div>







    </div>
    }
}

export default Myprofileaddress;
